module.exports = __webpack_public_path__ + "static/srt-alliance-logo-c717cc93bc3d03e99fd6ec67c6ea4db6.png";